import { render, staticRenderFns } from "./PromoFaq.vue?vue&type=template&id=98d77836&scoped=true&"
import script from "./PromoFaq.vue?vue&type=script&lang=js&"
export * from "./PromoFaq.vue?vue&type=script&lang=js&"
import style0 from "./PromoFaq.vue?vue&type=style&index=0&id=98d77836&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d77836",
  null
  
)

export default component.exports